import { FormulaOperation } from "./FormulaOperation";

/**
 * Приоритеты операций
 */
export const operationPriority: Record<FormulaOperation, number> = {
  "-": 1,
  "+": 1,
  "*": 2,
  "/": 2,
  "^": 3,
  "~": 4,
};
